import React from 'react';
import { TableVirtuoso } from 'react-virtuoso';
import { Icon, Dropdown, Menu, Button, Tooltip, Spin, message } from 'antd';
import moment from 'moment';
import { toBRL } from '~/components/UI/InputCurrency';
import Download from '~/components/Components/Download';

var STATUS_CONFIG = {
    'Ano anterior':  { color: '#bfbfbf', label: 'Ano anterior' },
    'Não iniciado': { color: '#595959', label: 'Não iniciado' },
    'Pendente':     { color: '#f5222d', label: 'Pendente' },
    'Em processo':  { color: '#fadb14', label: 'Em processo' },
    'Concluido':    { color: '#a0d911', label: 'Concluído' },
};

var PAYMENT_CONFIG = {
    'Pago':     { color: '#52c41a', label: 'Pago' },
    'Pendente': { color: '#f5222d', label: 'Pendente' },
};

var COL = {
    cod: 80, status: 110, origem: 150, name: undefined, birth: 110,
    cpf: 140, gov: 150, senha: 130,
    receipt: 140, receiptLast: 120,
    email: 200, whatsapp: 150, benefit: 140, procuration: 150,
    honLast: 130, honCurrent: 130, payStatus: 110,
    notes: 160, actions: 50
};
var TABLE_W = Object.keys(COL).reduce(function(s, k) { return s + (COL[k] || 0); }, 0) + 300;

var thBase = {
    padding: '8px 10px', background: '#fafafa',
    borderTop: '1px solid #e8e8e8', borderBottom: '1px solid #e8e8e8',
    borderRight: '1px solid #f0f0f0',
    fontWeight: 600, textAlign: 'left', whiteSpace: 'nowrap',
    overflow: 'hidden', textOverflow: 'ellipsis', fontSize: 12,
    color: '#595959', textTransform: 'uppercase', letterSpacing: '0.03em'
};
var tdBase = {
    padding: '10px 10px',
    borderBottom: '1px solid #f0f0f0', borderRight: '1px solid #f5f5f5',
    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: 13,
    transition: 'background 0.15s'
};

var stickyRightTh = { position: 'sticky', right: 0, zIndex: 3, boxShadow: '-3px 0 6px rgba(0,0,0,0.04)' };
var stickyRightTd = { position: 'sticky', right: 0, zIndex: 2, boxShadow: '-3px 0 6px rgba(0,0,0,0.04)' };

function thS(w, extra) { var s = Object.assign({}, thBase, extra); if (w) s.width = w; return s; }
function tdS(w, extra) { var s = Object.assign({}, tdBase, extra); if (w) s.width = w; return s; }

var SORTERS = {
    name: function(a, b) { return (a.name || '').localeCompare(b.name || ''); },
    origem: function(a, b) { return (a.origem || '').localeCompare(b.origem || ''); },
    birth_date: function(a, b) { return (a.birth_date || '').localeCompare(b.birth_date || ''); },
    procuration_due_date: function(a, b) { return (a.procuration_due_date || '').localeCompare(b.procuration_due_date || ''); },
};

function StatusDot(props) {
    var cfg = STATUS_CONFIG[props.state] || STATUS_CONFIG['Ano anterior'];
    return React.createElement('span', {
        style: { display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12 }
    },
        React.createElement('span', {
            style: {
                width: 8, height: 8, borderRadius: '50%', background: cfg.color,
                flexShrink: 0, boxShadow: '0 0 0 2px ' + cfg.color + '20'
            }
        }),
        React.createElement('span', { style: { color: cfg.color, fontWeight: 500 } }, cfg.label)
    );
}

function PaymentDot(props) {
    var cfg = PAYMENT_CONFIG[props.state] || PAYMENT_CONFIG['Pendente'];
    return React.createElement('span', {
        style: { display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12 }
    },
        React.createElement('span', {
            style: {
                width: 8, height: 8, borderRadius: '50%', background: cfg.color,
                flexShrink: 0, boxShadow: '0 0 0 2px ' + cfg.color + '20'
            }
        }),
        React.createElement('span', { style: { color: cfg.color, fontWeight: 500 } }, cfg.label)
    );
}

function getStatusLabel(record) {
    var h = record.honorary_of_current_year;
    if (!h) return 'Ano anterior';
    if (!h.created_at) return 'Não iniciado';
    if (h.process_step === 0) return 'Pendente';
    if (h.process_step === 2) return 'Em processo';
    if (h.process_step === 1) return 'Concluido';
    return 'Pendente';
}

function copyToClipboard(e, text, label) {
    if (e) e.stopPropagation();
    if (!text) return;
    navigator.clipboard.writeText(text);
    message.destroy();
    message.success(label + ' copiado para a área de transferência');
}

function CopyCell(props) {
    var text = props.text;
    var copyText = props.copyText || text;
    var label = props.label;
    if (!text) return null;
    return React.createElement('span', {
        className: 'copyable-cell',
        style: { display: 'inline-flex', alignItems: 'center', gap: 4, cursor: 'pointer' },
        onClick: function(e) { copyToClipboard(e, copyText, label); }
    },
        React.createElement('span', null, text),
        React.createElement(Icon, { type: 'copy', style: { fontSize: 11, color: '#bfbfbf', flexShrink: 0 } })
    );
}

function getFilename(data) {
    var now = moment().format('YYYY-MM-DD');
    return data.name + '_IRPF_' + now + '.pdf';
}

function formatBRL(value) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}

function TableFooter(props) {
    return React.createElement('div', {
        style: {
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '8px 12px', background: '#fafafa', borderTop: '1px solid #e8e8e8',
            fontSize: 12, color: '#8c8c8c'
        }
    },
        React.createElement('span', null,
            'Exibindo ',
            React.createElement('strong', { style: { color: '#262626' } }, props.showing),
            ' de ',
            React.createElement('strong', { style: { color: '#262626' } }, props.total),
            ' registros'
        )
    );
}

var TableList = function(props) {
    var filteredData = props.filteredData;
    var isLoading = props.isLoading;
    var onAction = props.onAction;
    var canSee = props.canSee;
    var currentYear = props.currentYear;
    var showActive = props.showActive;
    var onRowClick = props.onRowClick;
    var loadingRowId = props.loadingRowId;

    var sortState = React.useState(null);
    var sortField = sortState[0];
    var setSortField = function(v) { sortState[1](v); };

    var sortOrderState = React.useState(null);
    var sortOrder = sortOrderState[0];
    var setSortOrder = function(v) { sortOrderState[1](v); };

    function toggleSort(field) {
        if (sortField === field) {
            if (sortOrder === 'ascend') setSortOrder('descend');
            else { setSortField(null); setSortOrder(null); }
        } else {
            setSortField(field); setSortOrder('ascend');
        }
    }

    function sortIcon(field) {
        if (sortField !== field) {
            return React.createElement(Icon, { type: 'caret-down', style: { marginLeft: 4, fontSize: 10, opacity: 0.3 } });
        }
        return React.createElement(Icon, {
            type: sortOrder === 'ascend' ? 'caret-up' : 'caret-down',
            style: { marginLeft: 4, fontSize: 10, color: '#1890ff' }
        });
    }

    var processedData = React.useMemo(function() {
        var data = filteredData.slice();
        if (sortField && SORTERS[sortField]) {
            var sorter = SORTERS[sortField];
            data.sort(function(a, b) {
                var r = sorter(a, b);
                return sortOrder === 'descend' ? -r : r;
            });
        }
        return data;
    }, [filteredData, sortField, sortOrder]);

    var dataRef = React.useRef({});
    dataRef.current = { processedData: processedData, onAction: onAction, onRowClick: onRowClick, loadingRowId: loadingRowId };

    var tableComponents = React.useMemo(function() {
        return {
            Table: function(p) {
                return React.createElement('table', Object.assign({}, p, {
                    style: Object.assign({}, p.style, {
                        borderCollapse: 'separate', borderSpacing: 0,
                        tableLayout: 'fixed', width: '100%', minWidth: TABLE_W
                    })
                }));
            },
            TableRow: function(p) {
                var idx = p['data-item-index'];
                var isEven = idx % 2 === 0;
                var d = dataRef.current;
                var record = d.processedData[idx];
                var isRowLoading = record && d.loadingRowId === record.id;
                return React.createElement('tr', Object.assign({}, p, {
                    style: Object.assign({}, p.style, { cursor: 'pointer' }),
                    className: 'table-row' + (isEven ? ' table-row-even' : '') + (isRowLoading ? ' table-row-loading' : '') + (p.className ? ' ' + p.className : ''),
                    onClick: function(e) {
                        var tag = e.target.tagName;
                        if (tag === 'INPUT' || tag === 'A' || tag === 'BUTTON') return;
                        if (e.target.closest && (
                            e.target.closest('.ant-dropdown-trigger') ||
                            e.target.closest('.row-quick-actions') ||
                            e.target.closest('.copyable-cell')
                        )) return;
                        var d = dataRef.current;
                        var record = d.processedData[idx];
                        if (record && d.onRowClick) d.onRowClick(record);
                    }
                }));
            }
        };
    }, []);

    var year = currentYear.year();

    var fixedHeaderContent = React.useCallback(function() {
        return React.createElement('tr', null,
            React.createElement('th', { style: thS(COL.cod) }, 'CÓD'),
            React.createElement('th', { style: thS(COL.status) }, 'STATUS'),
            React.createElement('th', { style: thS(COL.origem, { cursor: 'pointer' }), onClick: function() { toggleSort('origem'); } },
                'ORIGEM', sortIcon('origem')),
            React.createElement('th', { style: thS(undefined, { cursor: 'pointer' }), onClick: function() { toggleSort('name'); } },
                'NOME', sortIcon('name')),
            React.createElement('th', { style: thS(COL.birth, { cursor: 'pointer', textAlign: 'center' }), onClick: function() { toggleSort('birth_date'); } },
                'NASC.', sortIcon('birth_date')),
            React.createElement('th', { style: thS(COL.cpf) }, 'CPF'),
            React.createElement('th', { style: thS(COL.gov) }, 'ACESSO GOV'),
            React.createElement('th', { style: thS(COL.senha) }, 'SENHA'),
            React.createElement('th', { style: thS(COL.receipt) }, 'RECIBO ' + year),
            React.createElement('th', { style: thS(COL.receiptLast) }, 'RECIBO ' + (year - 1)),
            React.createElement('th', { style: thS(COL.email) }, 'EMAIL'),
            React.createElement('th', { style: thS(COL.whatsapp) }, 'WHATSAPP'),
            React.createElement('th', { style: thS(COL.benefit) }, 'BENEFÍCIO'),
            React.createElement('th', { style: thS(COL.procuration, { cursor: 'pointer', textAlign: 'center' }), onClick: function() { toggleSort('procuration_due_date'); } },
                'VENC. PROC.', sortIcon('procuration_due_date')),
            canSee && React.createElement('th', { style: thS(COL.honLast, { textAlign: 'right' }) }, 'HON. ' + (year - 1)),
            canSee && React.createElement('th', { style: thS(COL.honCurrent, { textAlign: 'right' }) }, 'HON. ' + year),
            canSee && React.createElement('th', { style: thS(COL.payStatus) }, 'PGTO'),
            React.createElement('th', { style: thS(COL.notes) }, 'NOTAS'),
            React.createElement('th', { style: thS(COL.actions, Object.assign({ textAlign: 'center' }, stickyRightTh)) })
        );
    }, [sortField, sortOrder, year, canSee]);

    var itemContent = React.useCallback(function(index, record) {
        var isEven = index % 2 === 0;
        var rowBg = isEven ? '#fff' : '#fafbfc';

        var statusLabel = getStatusLabel(record);
        var h = record.honorary_of_current_year;

        var honLastYear = record.honoraries && record.honoraries.find(function(hon) { return hon.year === year - 1; });
        var honLastTotal = 0;
        if (honLastYear) {
            var addSum = (honLastYear.additionals || []).reduce(function(acc, cur) { return acc + cur.amount; }, 0);
            honLastTotal = honLastYear.amount + addSum;
        }

        var honCurrentTotal = 0;
        if (h) {
            var addSum2 = (h.additionals || []).reduce(function(acc, cur) { return acc + cur.amount; }, 0);
            honCurrentTotal = h.amount + addSum2;
        }

        return React.createElement(React.Fragment, null,
            // Cód
            React.createElement('td', { style: tdS(COL.cod, { background: rowBg, color: '#8c8c8c', fontSize: 12 }) },
                '#IRPF-' + record.id),
            // Status
            React.createElement('td', { style: tdS(COL.status, { background: rowBg }) },
                React.createElement(StatusDot, { state: statusLabel })),
            // Origem
            React.createElement('td', { style: tdS(COL.origem, { background: rowBg }) }, record.origem || ''),
            // Nome
            React.createElement('td', { style: tdS(undefined, { background: rowBg, fontWeight: 500 }) }, record.name || ''),
            // Nascimento
            React.createElement('td', { style: tdS(COL.birth, { background: rowBg, textAlign: 'center', color: '#8c8c8c' }) },
                record.birth_date ? moment(record.birth_date).format('DD/MM/YYYY') : ''),
            // CPF
            React.createElement('td', { style: tdS(COL.cpf, { background: rowBg }) },
                React.createElement(CopyCell, { text: record.doc_formated, copyText: record.doc_formated && record.doc_formated.replace(/[^0-9]/g, ''), label: 'CPF' })),
            // Acesso GOV
            React.createElement('td', { style: tdS(COL.gov, { background: rowBg }) },
                React.createElement(CopyCell, { text: record.e_cac, label: 'Acesso GOV' })),
            // Senha
            React.createElement('td', { style: tdS(COL.senha, { background: rowBg }) },
                React.createElement(CopyCell, { text: record.password, label: 'Senha' })),
            // Recibo current
            React.createElement('td', { style: tdS(COL.receipt, { background: rowBg }) },
                React.createElement(CopyCell, { text: record.receipt_number, copyText: record.receipt_number && record.receipt_number.replace(/\D/g, ''), label: 'Recibo' })),
            // Recibo last
            React.createElement('td', { style: tdS(COL.receiptLast, { background: rowBg }) },
                React.createElement(CopyCell, { text: record.receipt_number_of_last_year, copyText: record.receipt_number_of_last_year && record.receipt_number_of_last_year.replace(/\D/g, ''), label: 'Recibo' })),
            // Email
            React.createElement('td', { style: tdS(COL.email, { background: rowBg }) },
                React.createElement(CopyCell, { text: record.email, label: 'Email' })),
            // WhatsApp
            React.createElement('td', { style: tdS(COL.whatsapp, { background: rowBg }) },
                record.mobile_phone && record.mobile_phone.length > 10
                    ? React.createElement('a', {
                        href: 'https://wa.me/55' + record.mobile_phone,
                        target: '_blank',
                        rel: 'noopener noreferrer',
                        onClick: function(e) { e.stopPropagation(); },
                        style: { color: '#25d366', fontSize: 12, display: 'inline-flex', alignItems: 'center', gap: 4 }
                    }, React.createElement('img', { src: require('~/icons/WhatsappIcon/whatsapp.png'), alt: 'WhatsApp', style: { width: 14, height: 14 } }), record.phone_formated)
                    : (record.phone_formated || '')),
            // Benefício
            React.createElement('td', { style: tdS(COL.benefit, { background: rowBg }) },
                React.createElement(CopyCell, { text: record.benefit_number, label: 'Benefício' })),
            // Vencimento da Procuração
            React.createElement('td', { style: tdS(COL.procuration, { background: rowBg, textAlign: 'center', color: '#8c8c8c' }) },
                record.procuration_due_date ? moment(record.procuration_due_date).format('DD/MM/YYYY') : ''),
            // Honorary columns (conditional)
            canSee && React.createElement('td', { style: tdS(COL.honLast, { background: rowBg, textAlign: 'right', fontFamily: 'monospace', color: honLastTotal > 0 ? '#262626' : '#d9d9d9' }) },
                honLastTotal > 0 ? formatBRL(honLastTotal) : '-'),
            canSee && React.createElement('td', { style: tdS(COL.honCurrent, { background: rowBg, textAlign: 'right', fontFamily: 'monospace', color: honCurrentTotal > 0 ? '#262626' : '#d9d9d9' }) },
                honCurrentTotal > 0 ? formatBRL(honCurrentTotal) : '-'),
            canSee && React.createElement('td', { style: tdS(COL.payStatus, { background: rowBg }) },
                h ? React.createElement(PaymentDot, { state: h.payment_status }) : ''),
            // Notes
            React.createElement('td', { style: tdS(COL.notes, { background: rowBg, color: '#8c8c8c' }) }, record.notes || ''),
            // Actions
            React.createElement('td', { style: tdS(COL.actions, Object.assign({ textAlign: 'center', background: rowBg, overflow: 'visible' }, stickyRightTd)) },
                React.createElement('span', { onClick: function(e) { e.stopPropagation(); }, className: 'row-quick-actions' },
                    React.createElement(Dropdown, {
                        overlay: React.createElement(Menu, { onClick: function(e) { onAction(e, record); } },
                            !h && React.createElement(Menu.Item, { key: 'renew' },
                                React.createElement(Icon, { type: 'play-circle', style: { marginRight: 8 } }), 'Iniciar ' + year),
                            h && React.createElement(Menu.Item, { key: 'edit' },
                                React.createElement(Icon, { type: 'edit', style: { marginRight: 8 } }), 'Editar'),
                            h && h.created_at && React.createElement(Menu.Item, { key: 'print-cover' },
                                React.createElement(Download, { url: '/pf/customer/' + record.id + '/print?year=' + year, filename: getFilename(record) },
                                    React.createElement('div', null,
                                        React.createElement(Icon, { type: 'printer', style: { marginRight: 8 } }), 'Imprimir Capa'))),
                            h && h.created_at && React.createElement(Menu.Item, { key: 'print-receipt' },
                                React.createElement(Download, { url: '/pf/customer/' + record.id + '/receipt?year=' + year, filename: record.name + '_Recibo_' + year + '.pdf' },
                                    React.createElement('div', null,
                                        React.createElement(Icon, { type: 'printer', style: { marginRight: 8 } }), 'Imprimir Honorário'))),
                            React.createElement(Menu.Divider, null),
                            showActive
                                ? React.createElement(Menu.Item, { key: 'archive' },
                                    React.createElement(Icon, { type: 'delete', style: { marginRight: 8 } }), 'Arquivar')
                                : React.createElement(Menu.Item, { key: 'activate' },
                                    React.createElement(Icon, { type: 'check-circle', style: { marginRight: 8 } }), 'Ativar')
                        ),
                        trigger: ['click']
                    },
                        React.createElement(Button, { type: 'link', icon: 'more', style: { color: '#8c8c8c', padding: 0 } })
                    )
                )
            )
        );
    }, [year, canSee, onAction, showActive]);

    if (isLoading) {
        return React.createElement('div', {
            style: { display: 'flex', justifyContent: 'center', padding: '60px 0', background: '#fff', border: '1px solid #e8e8e8', borderRadius: 4 }
        }, React.createElement(Spin, { size: 'large' }));
    }

    if (processedData.length === 0) {
        return React.createElement('div', {
            style: {
                display: 'flex', flexDirection: 'column', alignItems: 'center',
                padding: '60px 20px', background: '#fff', border: '1px solid #e8e8e8', borderRadius: 4,
            }
        },
            React.createElement(Icon, { type: 'inbox', style: { fontSize: 48, color: '#d9d9d9', marginBottom: 16 } }),
            React.createElement('div', { style: { fontSize: 16, color: '#595959', fontWeight: 500, marginBottom: 8 } }, 'Nenhum registro'),
            React.createElement('div', { style: { fontSize: 13, color: '#8c8c8c', textAlign: 'center', maxWidth: 320 } },
                'Não há registros cadastrados para o período selecionado.')
        );
    }

    return React.createElement('div', null,
        React.createElement('style', { dangerouslySetInnerHTML: { __html:
            '.table-row:hover td { background: #f0f5ff !important; }\n' +
            '.table-row td { transition: background 0.15s; }\n' +
            '@keyframes rowPulse { 0%,100% { opacity: 1; } 50% { opacity: 0.4; } }\n' +
            '.table-row-loading td { animation: rowPulse 1s ease-in-out infinite; background: #f0f5ff !important; }\n' +
            '.table-row-loading { pointer-events: none; }'
        }}),
        React.createElement(TableVirtuoso, {
            style: { height: 'calc(100vh - 340px)', border: '1px solid #e8e8e8', borderRadius: '4px 4px 0 0' },
            data: processedData,
            components: tableComponents,
            fixedHeaderContent: fixedHeaderContent,
            itemContent: itemContent,
            overscan: 20
        }),
        React.createElement(TableFooter, { showing: processedData.length, total: filteredData.length })
    );
};

export default TableList;
